// Google Analytics 4 and Microsoft Clarity. Both stay off until their IDs are set in .env:
//   REACT_APP_GA_ID       e.g. G-XXXXXXXXXX
//   REACT_APP_CLARITY_ID  e.g. abcd1234ef
// Key actions tracked as GA4 events:
//   generate_lead (form_name: contact | quote | audit), whatsapp_click, phone_click,
//   email_click, outbound_click.
const GA_ID = process.env.REACT_APP_GA_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

// Skip automated browsers, including the pre-render step.
const isAutomated = typeof navigator !== 'undefined' && navigator.webdriver;
const isDev = process.env.NODE_ENV === 'development';

let initialised = false;

const loadScript = (src) => {
  const script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
};

const gtag = (...args) => {
  if (!GA_ID || isAutomated) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
};

export const trackEvent = (name, params = {}) => {
  if (isDev) console.debug('[analytics] event', name, params);
  gtag('event', name, params);
};

export const trackPageView = (path) => {
  if (isDev) console.debug('[analytics] page_view', path, document.title);
  gtag('event', 'page_view', {
    page_path: path,
    page_title: document.title,
    page_location: window.location.href
  });
};

// One listener classifies clicks on WhatsApp, phone, email and external links.
const handleClick = (event) => {
  const link = event.target.closest && event.target.closest('a[href]');
  if (!link) return;
  const href = link.getAttribute('href');

  if (href.includes('wa.me/')) {
    trackEvent('whatsapp_click', { link_url: href, page_path: window.location.pathname });
  } else if (href.startsWith('tel:')) {
    trackEvent('phone_click', { phone: href.slice(4), page_path: window.location.pathname });
  } else if (href.startsWith('mailto:')) {
    trackEvent('email_click', { page_path: window.location.pathname });
  } else if (/^https?:\/\//.test(href) && !href.includes(window.location.host)) {
    trackEvent('outbound_click', { link_url: href, page_path: window.location.pathname });
  }
};

export const initAnalytics = () => {
  if (initialised || isAutomated) return;
  initialised = true;

  if (GA_ID) {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
    gtag('js', new Date());
    // Page views are sent manually on every route change.
    gtag('config', GA_ID, { send_page_view: false });
  }

  if (CLARITY_ID) {
    window.clarity = window.clarity || function clarity(...args) {
      (window.clarity.q = window.clarity.q || []).push(args);
    };
    loadScript(`https://www.clarity.ms/tag/${CLARITY_ID}`);
  }

  if (GA_ID || isDev) {
    document.addEventListener('click', handleClick, true);
  }
};
